module.exports = __webpack_public_path__ + "static/iGOLogo-c13d04fe47cb59576afc5c3621d00a9e.png";